//泰语
export default {
  tip: {
    fromSuccess: "ส่งสำเร็จ",
  },
  login: {
    linkList: [
      { name: "ดาวหนึ่งห้างสรรพสินค้า", url: "/" },
      {
        name: "ลงทะเบียนเป็นผู้ประกอบการค้า",
        url: "https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv",
      },
    ],
    registered: {
      text: "ไม่มีบัญชี คลิกเพื่อลงทะเบียน>>",
      url: "https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv",
    },
    shouye: {
      url: "/",
    },
    // forgot:'ลืมรหัสผ่าน？',
    // title:'เข้าสู่ระบบบัญชี',
    // email:'ไปรษณียภัณฑ์',
    // pwd:'รหัสผ่าน',
    // denglu:'ล็อกอิน',
    // mima:'ลืมรหัสผ่าน',
    // Reset: 'ตั้งค่ารหัสผ่านใหม่',
    // p_email: 'โปรดระบุกล่องจดหมาย',
    // p_pwd: 'กรุณาใส่รหัสผ่าน',
    // p_new_pwd: 'กรุณาป้อนรหัสผ่านใหม่',
    // z_email: 'กรุณาป้อนที่อยู่อีเมลที่ถูกต้อง',
    // long:'ความยาวของตัวอักษรใน 6-18',
    // determine:'ยืนยัน',
    // Valid:'การตั้งค่ารหัสผ่านที่ได้รับการส่งกรุณาตรวจสอบอีเมลของคุณสำหรับการตั้งค่าการเชื่อมโยงการเชื่อมโยงที่ถูกต้องในชั่วโมง',
    // Help_reset:'ป้อนอีเมลที่คุณลงทะเบียนและเราจะช่วยให้คุณตั้งค่ารหัสผ่านของคุณ'

    forgot: " ลืมรหัสผ่าน",
    title: " เข้าสู่ระบบบัญชี",
    email: " ไปรษณียภัณฑ์",
    pwd: " ภาษาใบ้ ",
    denglu: " เข้าสู่ระบบ ",
    mima: " ลืมรหัสผ่าน ",
    Reset: " ตั้งค่ารหัสผ่านใหม่ ",
    p_email: " กรุณาป้อนอีเมล ",
    p_pwd: " กรุณาใส่รหัสผ่าน ",
    p_new_pwd: " กรุณาใส่รหัสผ่านของคุณ ",
    z_email: " กรุณาป้อนที่อยู่อีเมลที่ถูกต้อง ",
    long: " ความยาวเป็น 6-18 ตัวอักษร ",
    determine: " ยืนยัน ",
    Valid:
      " รหัสผ่านการตั้งค่าโปรแกรมที่ได้รับการส่ง กรุณาตรวจสอบอีเมลของคุณและตรวจสอบการตั้งค่าการเชื่อมโยง การเชื่อมโยงที่ถูกต้องในชั่วโมง ",
    Help_reset:
      " ป้อนที่อยู่อีเมลที่ลงทะเบียนของคุณและเราจะช่วยให้คุณตั้งค่ารหัสผ่านของคุณ ",
    loginName: " ล็อกอิน ",
  },
  myhead: {
    loginName: "ล็อกอิน",
    Personalcenter: "บัญชีผู้ใช้",
    placeholder: "ระบุหมายเหตุ (ถ้ามี)",
    myhead_a: "การเทรด",
    myhead_b: "การเทรด",
    myhead_bc: "แพลตฟอร์มการซื้อขาย",
    myhead_c: "",
    myhead_d: "ศูนย์การเรียนรู้",
    myhead_e: "เกี่ยวกับเรา",
    myhead_f: "ดาวช่วยคุณ",
    myhead_g: "กลายเป็นผู้ค้าที่ดีที่สุด",
    myhead_h: "เปิดบัญชีจริง",
    myhead_i: "เริ่มต้นบัญชีจำลอง",
    myhead_j: {
      text: "แคมเปญออนไลน์",
      url: "https://www.interstellarfx.net/zh/trade-cashback",
    },
    myhead_k: "การคืนเงินสด",
    myhead_l: "ซื้อขายสินค้า",
    myhead_m: "ธุรกรรมที่เกี่ยวข้อง",
    myhead_n: "โรงเรียนแลกเปลี่ยนเงินตราต่างประเทศ",
    myhead_o: "เทศกาลกลางฤดูใบไม้ร่วงจุดรางวัลกิจกรรม",
    myhead_p: "ประกาศจาก InterStellar",
    myhead_q: "การคาดการณ์สภาวะตลาด",

    myhead_r:
      "ในฐานะผลิตภัณฑ์การซื้อขายทางการเงินที่ซับซ้อน สัญญาส่วนต่าง Contracts for Difference (CFDs) มีความเสี่ยงสูงอย่างมากเนื่องจากคุณสมบัติของเลเวอเรจ บัญชีลูกค้าของนักลงทุนรายย่อยส่วนใหญ่มักบันทึกการสูญเสียเงินลงทุนในสัญญาส่วนต่างอย่างรวดเร็ว คุณควรพิจารณาว่า คุณมีความเข้าใจเกี่ยวกับกฎเกณฑ์การดำเนินงานของสัญญาส่วนต่าง และสามารถรับความเสี่ยงสูงของการสูญเสียเงินลงทุนได้หรือไม่",
    myhead_s: "บริษัท",
    myhead_t: "ตลาด",
    myhead_u: "หลัก",
    myhead_v: "บทวิเคราะห์และการเรียนรู้",
    myhead_v_a: " บทวิเคราะห์",
    myhead_v_b: "การเรียนรู้",
    myhead_w: "การกำกับดูแล",
    myhead_x: "ประกันภัย",
    myhead_y: "การปฏิบัติตามกฎหมาย",
    myhead_z: "ข่าวสารล่าสุด",
    myhead_aa: "คู่มือการซื้อขาย",
    myhead_bb: "คำศัพท์เกี่ยวกับการเทรด",
    myhead_cc: "ข่าวด่วน",
    myhead_dd: "การวิเคราะห์ธุรกรรม",
    myhead_ee: "การลงทุน forex",
    myhead_ff: "การสนับสนุน & ความรับผิดชอบต่อสังคม",
    myhead_gg: "ISG การสัมมนาผ่านเ",
    myhead_hh: "การวิเคราะห์ FISG",
    myhead_ii: "คอร์สสอนเทรด",
    myhead_com: "แข่งเทรดจำลอง InterStellar Group",
  },
  Home: {
    // Home_a:' ศูนย์การค้าดารา ',
    // Home_b:'จุดซื้อขายของขวัญ',
    // Home_c:'ของขวัญที่ดีดิจิตอลแฟชั่นเครื่องใช้ไฟฟ้าที่ซับซ้อนรถยนต์หรูด้านบนและจุดซื้อขายอื่นๆอีกมากมายที่ดีที่จะนำกลับบ้าน',
    // Home_d:'ดูข้อตกลงและเงื่อนไขของกิจกรรมที่ใช้',
    // Home_e:'คลิก',
    // Home_f:'ที่นี่',
    // Home_g:'ของขวัญที่ดีสำหรับคุณ',
    // Home_h:'ไม่มีของขวัญที่คุณต้องการ',
    // Home_i:'ยินดีต้อนรับคุณสามารถแนะนำผลิตภัณฑ์ที่คุณต้องการเราก็จะแนะนำผลิตภัณฑ์เสริมตามความนิยมของของขวัญ',
    // Home_j:'ของขวัญยี่ห้อ',
    // Home_k:'รายละเอียดสินค้า',
    // Home_l:'โค้งงอ',
    // Home_m:'รางวัลคะแนนแลกเปลี่ยนกฎ',
    // Home_n:'วิธีการได้รับคะแนน',
    // Home_o:'ลูกค้าแลกเปลี่ยนเงินตราต่างประเทศใดๆที่ซื้อขายคู่สกุลเงินโลหะมีค่าและผลิตภัณฑ์พลังงานบนแพลตฟอร์มของเราจะได้รับหนึ่งเครดิตสำหรับแต่ละรายการ',
    // Home_p:'วิธีการแลกเปลี่ยนของขวัญ',
    // Home_q:'ส่งใบสมัครของคุณที่จุดศูนย์การค้ากรอกชื่อของคุณข้อมูลที่ติดต่อและหมายเลขบัญชีซื้อขายหลังเวทีจะตรวจสอบคะแนนของคุณและไม่ว่าธุรกรรมที่ผิดกฎหมายเมื่อเร็วๆนี้ได้รับ',
    // Home_r:'เวลาของขวัญ',
    // Home_s:'ของขวัญจะถูกส่งในวันหลังจากได้รับการอนุมัติสำหรับการแลกเปลี่ยนโปรดทราบว่าถ้าคุณต้องการตรวจสอบคุณสามารถติดต่อผู้จัดการฝ่ายบริการลูกค้าของคุณเองเพื่อตรวจสอบความคืบหน้า',
    // Home_t:'รายละเอียดหลังการขาย',
    // Home_u:'สินค้าทั้งหมดที่ระบุไว้ในห้างสรรพสินค้าโดยซัพพลายเออร์ของบุคคลที่สามไม่สนับสนุนการกลับมาที่ไร้เหตุผล อย่างไรก็ตามหากมีของขวัญผิดพลาดหรือเสียหายในระหว่างการขนส่งคุณสามารถติดต่อฝ่ายบริการลูกค้าพิเศษของคุณเพื่อแก้ไขปัญหา',
    // Home_v:'แนะนำยอดนิยม',
    // Home_w:'สินค้ายอดนิยมกำลังรอคุณอยู่',
    // Home_x:'เวรยาม',
    // Home_y:'จุดสำคัญ',
    // Home_z:'เลือกยี่ห้อ',
    // Home_aa:'อาร์เรย์ผลิตภัณฑ์ใหม่',
    // Home_bb:'จุดเรียง',
    // Home_cc:'เลือกยี่ห้อ',
    // Home_dd:'เพียงแต่',
    // Home_ee:'คะแนนแปลงสภาพ',
    // Home_ff:'กรุณาระบุยี่ห้อของขวัญ',
    // Home_gg:'ดระบุรายละเอียดผลิตภัณฑ์',
    // Home_hh:'โปรดระบุรายละเอียดผลิตภัณฑ์',
    // Home_hh:'ข้อตกลง',
    // Home_ii:'ประสบความสำเร็จ',
    // Home_zz:'ศูนย์การค้าแบบองค์รวม',
    // Home_kk:'ศูนย์การค้าแบบองค์รวม',
    Home_a: "กลับสู่หน้าหลัก",
    Home_b: "ของขวัญสุดพิเศษสำหรับคุณ ! ",
    Home_c:
      "แลกแต้มเป็นของขวัญสุดพิเศษ เช่น แฟชั่น ดิจิตอล , เครื่องใช้ไฟฟ้าสุดหรู , รถหรูชั้นนำและสินค้าอื่นๆได้ตลอดเวลา ",

    Home_d: "ดูข้อตกลงและเงื่อนไขของกิจกรรมที่ใช้",
    Home_e: "คลิก",
    Home_f: "ที่นี่",
    Home_g: "ของรางวัลสุดพิเศษ สำหรับคุณ",
    Home_h: "ไม่มีของขวัญที่คุณต้องการ",
    Home_i:
      "ยินดีต้อนรับคุณสามารถแนะนำผลิตภัณฑ์ที่คุณต้องการเราก็จะแนะนำผลิตภัณฑ์เสริมตามความนิยมของของขวัญ",
    Home_j: "ของขวัญยี่ห้อ",
    Home_k: "รายละเอียดสินค้า",
    Home_l: "ยืนยัน",
    Home_m: "เงื่อนไขการแลกของรางวัล ",
    Home_n: "วิธีการได้รับคะแนน",
    Home_o:
      "ลูกค้าแลกเปลี่ยนเงินตราต่างประเทศใดๆที่ซื้อขายคู่สกุลเงินโลหะมีค่าและผลิตภัณฑ์พลังงานบนแพลตฟอร์มของเราจะได้รับหนึ่งเครดิตสำหรับแต่ละรายการ",
    Home_p: "วิธีการแลกเปลี่ยนของขวัญ",
    Home_q:
      "ยื่นคำขอแลกแต้ม (กรอกชื่อข้อมูลติดต่อ หมายเลขบัญชีซื้อขาย และข้อมูลอื่นๆ ของคุณ)  ทีมงานจะตรวจสอบคะแนนของคุณว่ามีการทําธุรกรรมตรงตามเงื่อนไขสำหรับแลกรางวัลหรือไม่ *เมื่อแลกแล้วไม่สามารถยกเลิกได้* ",
    Home_r: "ระยะเวลาในการจัดส่งของรางวัล",
    Home_s:
      "ของขวัญจะถูกจัดส่งภายใน 15 วันหลังจากคำขอแลกเปลี่ยนได้รับการอนุมัติ ,โปรดทราบว่าระหว่างการตรวจสอบ คุณสามารถติดต่อผู้จัดการฝ่ายบริการลูกค้าเพื่อตรวจสอบความคืบหน้าในการจัดส่งได้ ",
    Home_t: "รายละเอียดหลังการขาย",
    Home_u:
      "สินค้าทั้งหมดที่ลูกค้าได้ทำการแลกเปลี่ยนเป็นของรางวัล ทางเราจะไม่ขอรับคืนสินค้าที่ลูกค้าทำการแลกเปลี่ยนไปแล้ว แต่ หากสินค้าเกิดความเสียหายหรือข้อผิดพลาดใด ๆ ลูกค้าสามารถติดต่อฝ่ายบริการลูกค้าเพื่อแก้ไขปัญหาได้ ",
    Home_v: "แนะนำยอดนิยม",
    Home_w: "สินค้ายอดนิยมกำลังรอคุณอยู่",
    Home_x: "แลกรางวัล",
    Home_y: "Point",
    Home_z: "Brand",
    Home_aa: "สินค้าใหม่ ่",
    Home_bb: "ระดับคะแนน",
    Home_cc: "เลือกยี่ห้อ",
    Home_dd: "เพียงแต่",
    Home_ee: "คะแนนแปลงสภาพ",
    Home_ff: "กรุณาระบุยี่ห้อของขวัญ",
    Home_gg: "โปรดระบุรายละเอียดผลิตภัณฑ์",
    Home_hh: "ข้อตกลง",
    Home_ii: "ประสบความสำเร็จ",
    Home_zz: "Point Mall",
    Home_kk: "POINTS MALL",
    Home_search: "ค้นหา",
    seckill: "ซุปเปอร์สेलด่วน",
    daySeckill: "เวลาเซลด่วนประจำวัน",
    cutDownTips: "กล่องตาบอด จำกัด เวลาคว้านับถอยหลัง",
    cutDownTips1: "กล่องบลindsight การขายด่วนจบ",
    cutDownTips2: "กล่องบลindsight การขายด่วนนอกช่วงเวลา",
    cutDownTips3: "กิจกรรมยังไม่เริ่ม",
  },
  detail: {
    // detail_a:'กลับไปยังหน้าหลักของห้างสรรพสินค้า',
    // detail_b:'นางแบบ',
    // detail_c:'ตัวเลข',
    // detail_d:'รายละเอียดการแลกเปลี่ยนของขวัญ',
    // detail_e:'ของขวัญจะถูกส่งถึงคุณในวันหลังจากที่ได้รับการอนุมัติสำหรับการแลกเปลี่ยนโปรดทราบว่าคุณสามารถติดต่อผู้จัดการฝ่ายบริการลูกค้าพิเศษของคุณเพื่อตรวจสอบความคืบหน้า',
    // detail_f:'สินค้าทั้งหมดที่ระบุไว้ในห้างสรรพสินค้า Interpoint จะถูกจัดหาโดยซัพพลายเออร์ของบุคคลที่สามและไม่สนับสนุนการกลับมาโดยไม่มีเหตุผล อย่างไรก็ตามหากมีของขวัญที่ไม่ถูกต้องหรือเสียหายในระหว่างการขนส่งคุณสามารถติดต่อฝ่ายบริการลูกค้าพิเศษของคุณเพื่อแก้ไขปัญหา',
    // detail_g:'รายละเอียดสินค้า',
    // detail_h:'รายละเอียดสินค้า',
    // detail_i:'แนะนำยอดนิยม',
    detail_a: "กลับไปหน้าหลัก",
    detail_b: "Model",
    detail_c: "จำนวน",
    detail_d: "รายละเอียดการแลกเปลี่ยนของขวัญ",
    detail_e:
      "ของขวัญจะถูกส่งถึงคุณในวันหลังจากที่ได้รับการอนุมัติสำหรับการแลกเปลี่ยนโปรดทราบว่าคุณสามารถติดต่อผู้จัดการฝ่ายบริการลูกค้าพิเศษของคุณเพื่อตรวจสอบความคืบหน้า",
    detail_f:
      "สินค้าทั้งหมดที่ระบุไว้ในห้างสรรพสินค้า Interpoint จะถูกจัดหาโดยซัพพลายเออร์ของบุคคลที่สามและไม่สนับสนุนการกลับมาโดยไม่มีเหตุผล อย่างไรก็ตามหากมีของขวัญที่ไม่ถูกต้องหรือเสียหายในระหว่างการขนส่งคุณสามารถติดต่อฝ่ายบริการลูกค้าพิเศษของคุณเพื่อแก้ไขปัญหา",
    detail_g: "รายละเอียดสินค้า",
    detail_h: "แนะนำยอดนิยม",
    detail_i: "กรุณาเข้าสู่ระบบ",
  },
  settlement: {
    balance: "คะแนนที่มีอยู่ปัจจุบัน",
    // settlement_a:'เพิ่มที่อยู่การเก็บเกี่ยว',
    // settlement_b:'ข้อมูลการสั่งซื้อ',
    // settlement_c:'นาม',
    // settlement_d:'สเปค',
    // settlement_e:'ราคาต่อหน่วย',
    // settlement_f:'ตัวเลข',
    // settlement_g:'ข้อมูลผู้รับ',
    // settlement_h:'เพิ่มที่อยู่',
    // settlement_i:'ตัดสิน',
    // settlement_z:'จุดสำคัญ',
    // settlement_k:'แก้ปัญหาทันท',
    // settlement_title:'ส่งเรียบร้อยแล้ว',
    // settlement_tip:'คำสั่งแลกเปลี่ยนเงินตราของคุณจะถูกส่งไปยังคุณในวันธรรมดา นอกจากนี้คุณยังสามารถติดต่อผู้จัดการฝ่ายบริการลูกค้าพิเศษเพื่อตรวจสอบความคืบหน้าการส่งมอบ',
    // settlement_button:'ตัดสิน',
    settlement_tip_error:
      "คะแนนของท่านไม่เพียงพอสำหรับการทำรายการ กรุณาตรวจสอบคะแนนของท่านก่อนดำเนินการแลกสินค้า หากต้องการความช่วยเหลือเพิ่มเติม โปรดติดต่อฝ่ายบริการลูกค้า",
    settlement_a: "ข้อมูลการสั่งซื้อ",
    settlement_b: "นาม",
    settlement_c: "สเปค",
    settlement_d: "ราคา",
    settlement_e: "จำนวน",
    settlement_f: "ข้อมูลผู้รับ",
    settlement_g: "เพิ่มที่อยู่",
    settlement_h: "คะแนนที่ต้องการแลก",
    settlement_i: "จุดสำคัญ",
    settlement_z: "แลกคะแนน",
    settlement_k: "ส่งเรียบร้อยแล้ว",
    settlement_l: "กรุณายืนยันการสั่งซื้อของคุณ",
    settlement_m: "สินค้า",
    settlement_n: "ข้อมูลสินค้า",
    settlement_o: "ข้อมูลคะแนน!",
    settlement_p: "คะแนนของคุณไม่เพียงพอสำหรับการทำรายการ",
    settlement_title: "แลกคะแนน",
    settlement_tip:
      "การดำเนินการแลกเปลี่ยนคะแนนของท่านจะถูกดำเนินการในวันทำการ หากต้องการตรวจสอบสถานะ ท่านสามารถติดต่อฝ่ายบริการลูกค้าเพื่อ ตรวจสอบความคืบหน้าการส่งมอบ",
    settlement_button: "ยืนยัน",
    settlement_button_err: "ยกเลิก",
  },
  meber: {
    // meber_a:'ศูนย์สั่งซื้อ',
    //       meber_b:'ศูนย์บุคคล',
    // meber_c:'คำสั่งของฉัน',
    // meber_d:'การจัดการที่อยู่',
    // meber_e:'ยกเลิก',
    meber_a: "ศูนย์สั่งซื้อ",
    meber_b: "บัญชีผู้ใช้",
    meber_c: "คำสั่งของฉัน",
    meber_d: "การจัดการที่อยู่",
    // meber_e: 'ยกเลิก',
    meber_e: "ออกจากระบบ",
  },

  address: {
    // address_a:'เจริญเติบโต',
    // address_b:'นาม',
    // address_c:'การส่งเสียงเอะอะ',
    // address_d:'แถมท้าย',
    // address_e:'การเคลื่อนไหว',
    // address_f:'ตัดต่อ',
    // address_g:'ตัดออก',
    // address_h:'โปรดเลือก',
    // address_i:'รายละเอียดที่อยู่',
    // address_j:'ไถ่บาป',
    // address_k:'ใส่ชื่อของคุณ',
    // address_l:'กรุณาใส่หมายเลขโทรศัพท์ของคุณ',
    // address_m:'รูปแบบหมายเลขโทรศัพท์ที่ไม่ถูกต้อง',
    // address_n:'กรุณาใส่หมายเลขโทรศัพท์ของคุณ',
    // address_o:'กรุณาป้อนที่อยู่เต็ม',
    // address_p:'แก้ไขเรียบร้อยแล้ว',
    // address_q:'เพิ่มความสำเร็จ',
    // address_r:'ลบสำเร็จ',
    // address_s:'ที่อยู่เก็บเกี่ยวใหม่',
    // address_t:'คุณยังไม่ได้เพิ่มที่อยู่จัดส่ง',

    address_a: "เจริญเติบโต",
    address_b: "ชื่อ-นามสกุล",
    address_c: "หมายเลขโทรศัพท์",
    address_d: "หมายเลขโทรศัพท์",
    address_e: "การเคลื่อนไหว",
    address_f: "ตัดต่อ",
    address_g: "ตัดออก",
    address_h: "โปรดเลือก",
    address_i: "รายละเอียดที่อยู่",
    address_j: "ยืนยัน",
    address_k: "ใส่ชื่อของคุณ",
    address_l: "กรุณาใส่หมายเลขโทรศัพท์ของคุณ",
    address_m: "รูปแบบหมายเลขโทรศัพท์ที่ไม่ถูกต้อง",
    address_n: "กรุณาใส่หมายเลขโทรศัพท์ของคุณ",
    address_o: "กรุณาป้อนที่อยู่เต็ม",
    address_p: "แก้ไขเรียบร้อยแล้ว",
    address_q: "เพิ่มความสำเร็จ",
    address_r: "ลบสำเร็จ",
    address_s: "ที่อยู่จัดส่ง",
    address_t: "คุณยังไม่ได้เพิ่มที่อยู่จัดส่ง",
  },

  order: {
    // order_a:'คำสั่งของฉัน',
    // order_b:'เดท',
    // order_c:'หมายเลขการสั่งซื้อ',
    // order_d:'ผู้รับ',
    // order_e:'จำนวนรวม',
    // order_f:'รายละเอียดการสั่งซื้อ',
    // order_g:'การส่งเสียงเอะอะ',
    // order_h:'แถมท้าย',
    // order_i:'สภาพ',
    // order_j:'โหมดของการขนส่ง',
    // order_k:'การเคลื่อนไหว',
    // order_l:'ปิดกล้อง',
    // order_m:'สร้าง',
    // order_n:'จ่ายเงิน',
    // order_o:'การคืนเงิน',
    // order_p:'คืนเงิน',
    // order_q:'โดยสารทางน้ำ',
    // order_r:'จบ',
    // order_s:'คะแนนต้นทุน',

    order_a: "คำสั่งของฉัน",
    order_b: "เดท",
    order_c: "หมายเลขการสั่งซื้อ",
    order_d: "ผู้รับ",
    order_e: "จำนวนรวม",
    order_f: "รายละเอียดการสั่งซื้อ",
    order_g: "การส่งเสียงเอะอะ",
    order_h: "แถมท้าย",
    order_i: "สภาพ",
    order_j: "โหมดของการขนส่ง",
    order_k: "การเคลื่อนไหว",
    order_l: "ปิดกล้อง",
    order_m: "สร้าง",
    order_n: "จ่ายเงิน",
    order_o: "การคืนเงิน",
    order_p: "คืนเงิน",
    order_q: "โดยสารทางน้ำ",
    order_r: "จบ",
    order_s: "คะแนนต้นทุน",
  },

  userinfo: {
    // userinfo_a:'คะแนนต้นทุน',
    // userinfo_b:'ศูนย์บุคคล',
    // userinfo_c:'เวลาการปรับปรุงล่าสุด',
    // userinfo_d:'กล่องจดหมายของผู้ใช้',

    userinfo_a: "บัญชีผู้ใช้",
    userinfo_b: "เวลาการปรับปรุงล่าสุด",
    // userinfo_c: 'กล่องจดหมายของผู้ใช้',
    userinfo_c: "อีเมล",
    // userinfo_d: 'เครดิตใช้ได้',
    userinfo_d: "คะแนน",
  },

  orderDetail: {
    // orderDetail_a:'เครดิตใช้ได้',
    // orderDetail_b:'ส่งคำสั่ง',
    // orderDetail_c:'ความสำเร็จของการชำระเงิน',
    // orderDetail_d:'กระทง',
    // orderDetail_e:'เสร็จสิ้น',
    // orderDetail_f:'วิธีการชำระเงิน',
    // orderDetail_g:'ชื่อผู้ส่ง',
    // orderDetail_h:'สอบถาม'

    orderDetail_a: "ส่งคำสั่ง",
    orderDetail_b: "ความสำเร็จของการชำระเงิน",
    orderDetail_c: "กระทง",
    orderDetail_d: "รอการจัดส่ง",
    orderDetail_e: "เสร็จสิ้น",
    orderDetail_f: "วิธีการชำระเงิน",
    orderDetail_g: "ชื่อผู้ส่ง",
    orderDetail_h: "หมายเลขแบบสอบถาม",
  },

  footerbox: {
    footerbox_b: "ตลาดทั่วโลกวันนี้",
    footerbox_c: "ลองสาธิตฟรี",
    footerbox_d: "บริการลูกค้าในภูมิภาคเอเชียแปซิฟิก",
    footerbox_e: "กล่องจดหมายของบริษัท",
    footerbox_f: "support@interstellarsfx.com",

    footerbox_g: "การเริ่มเทรด",
    footerbox_h: "ฟอเร็กซ์",
    footerbox_i: "โลหะมีค่า",
    footerbox_ik: "การซื้อขายหุ้น",
    footerbox_j: "พลังงาน",
    footerbox_k: "ดัชน",
    footerbox_a: "เกี่ยวกับการซื้อขาย",

    footerbox_l: "ECN",
    footerbox_m: "ประเภทบัญชี",
    footerbox_ml: "นโยบายการใช้ Leverage",
    footerbox_n: "การฝากและการถอน",
    footerbox_o: "เปิดบัญชีจริง",
    footerbox_p: "เปิดบัญชีจำลอง ",

    footerbox_q: "เครื่องมือการซื้อขาย",
    footerbox_r: "MetaTrader 4",
    footerbox_s: "MAM",
    footerbox_t: "MultiTerminal",
    footerbox_x: "การวิเคราะห์ทางเทคนิค",
    footerbox_v: "เครื่องมือคำนวณการซื้อขาย",
    footerbox_w: "VPS",
    footerbox_u: "ปฏิทินเศรษฐกิจ",

    footerbox_y: "โรงเรียนธุรกิจ",
    footerbox_z: "การรวบรวมคำศัพท์",

    footerbox_aa: "เกี่ยวกับ InterStellar",
    footerbox_ad: "เกี่ยวกับเรา",
    footerbox_bb: "สรรหาบุคลากร",
    footerbox_cc: "สรรหาบุคลากร",
    footerbox_dd: "ติดต่อเรา",
    footerbox_ee: "พาร์ทเนอร์ของโบรกเกอร์ FISG",
    footerbox_ff: "FAQ",

    footerbox_mm: "ข้อจำกัดความรับผิดชอบ:",
    footerbox_nn:
      "เว็บไซต์ www.interstellarsfx.com ดำเนินการโดย First Interstellar Global Ltd ซึ่งเป็นบริษัทจำกัดที่จัดตั้งขึ้นภายใต้กฎหมายของประเทศเซเชลส์ โดยมีหมายเลขทะเบียน [ใส่หมายเลขทะเบียนบริษัท] และที่อยู่จดทะเบียนที่ห้อง 9 อาคาร Deenu, Providence , มาเฮ, เซเชลส์ First Interstellar Global Ltd ได้รับอนุญาตและควบคุมโดย Financial Services Authority of Seychelles โดยมีใบอนุญาตเลขที่ SD127. First Interstellar Global Ltd ไม่ได้เป็นส่วนหนึ่งของการกำกับดูแลทางการเงินของยุโรป Markets in Financial Instruments Directive (MiFID) II รวมถึงกฎระเบียบด้านบริการทางการเงินอื่นๆ ของยุโรป ไม่มีผลบังคับใช้กับการให้บริการทางการเงินของ First Interstellar Global Ltd. นอกจากนี้ยังไม่มีข้อกำหนดสำหรับแผนการจ่ายผลตอบแทนแก่นักลงทุน",
    footerbox_gg:
      "InterstellarFX ไม่เสนอ CFD ให้กับผู้ที่อาศัยอยู่ในเขตอำนาจศาลบางแห่ง รวมถึงสหรัฐอเมริกา อิหร่าน แคนาดา เบลเยียม และฝรั่งเศส เป็นต้น",
    footerbox_hh: "คำเตือนเกี่ยวกับความเสี่ยง: ",
    footerbox_ii:
      "การซื้อขายแลกเปลี่ยนเงินตราต่างประเทศและผลิตภัณฑ์ทางการเงินที่มีเอเวอเรตมีความเสี่ยงสูงและอาจทำให้คุณสูญเสียเงินต้นได้ ดังนั้นคุณไม่ควรรับความเสี่ยงจากการสูญเสียมากเกินกว่าที่คุณจะจ่ายได้ และโปรดแน่ใจว่าคุณเข้าใจความเสี่ยงที่เกี่ยวข้องอย่างถ่องแท้ ผลิตภัณฑ์เลเวอเรจการซื้อขายไม่เหมาะสำหรับนักลงทุนทุกคน การซื้อขายผลิตภัณฑ์ที่ไม่มีเลเวอเรจ เช่น หุ้นก็มีความเสี่ยงเช่นกัน เนื่องจากมูลค่าของหุ้นสามารถลดลงและเพิ่มขึ้นได้ ซึ่งหมายความว่าคุณอาจได้รับเงินคืนน้อยกว่าที่คุณลงทุนไปในตอนแรก ประสิทธิภาพในอดีตไม่ได้รับประกันผลลัพธ์ในอนาคต ก่อนทำการซื้อขายโปรดพิจารณาระดับประสบการณ์ของคุณและวัตถุประสงค์ในการลงทุน และขอคำแนะนำทางการเงินอิสระหากจำเป็น เป็นความรับผิดชอบของลูกค้าเองที่จะต้องตรวจสอบให้แน่ใจว่าข้อกำหนดทางกฎหมายของประเทศที่พำนักของลูกค้าได้อนุญาตให้ลูกค้าใช้บริการจากแบรนด์ StarWorld",
    footerbox_zz: "ระบุถึงความเสี่ยง",
    footerbox_kk: "นโยบายความเป็นส่วนตัว",
    footerbox_ll: "Copyright © 2021 FISG. All rights reserved.",
  },
  other: {
    sections: {
      about: "เกี่ยวกับ FISG",
      trading: "การเทรด",
      campaigns: "แคมเปญ",
      education: "ศูนย์การเรียนรู้",
      markets: "ตลาด",
    },
    about: {
      title: "First InterStellar Group",
      aboutFISG: "เกี่ยวกับ FISG",
      legalCompliance: "การปฏิบัติตามกฎหมาย",
      clientReviews: "รีวิวลูกค้า",
      insurance: "ประกันภัย",
      events: "อีเวนต์ของ FISG",
      partnership: "ความร่วมมือ",
    },
    trading: {
      platformTitle: "แพลตฟอร์มการเทรด",
      mt4: "MetaTrader 4",
      mt5: "MetaTrader 5",
      webTerminal: "MetaTrader WebTerminal",
      copyTrade: "Copy Trade",
      app: "FISG APP",
      marketsTitle: "ผลิตภัณฑ์",
      forex: "Forex",
      metals: "โลหะ",
      energy: "พลังงาน",
      index: "ดัชนี",
      stock: "หุ้น",
      cryptocurrency: "คริปโตเคอเรนซี",
      accountTitle: "บัญชี",
      accountTypes: "ประเภทบัญชี",
      leverage: "นโยบายเลเวอเรจ",
      depositWithdrawal: "ฝากและถอนเงิน",
      toolsTitle: "เครื่องมือการเทรด",
      mam: "MAM",
      pamm: "PAMM",
      multiTerminal: "MultiTerminal",
      calculator: "เครื่องคำนวณ Forex",
    },
    campaigns: { title: "แคมเปญ" },
    education: {
      title: "ศูนย์การเรียนรู้",
      seminar: "สัมมนา",
      whatIsForex: "Forex Trading คืออะไร?",
      course: "คอร์สเรียนการเทรด",
      investment: "การลงทุน Forex",
      glossary: "คำศัพท์การเทรด",
      faq: "คำถามที่พบบ่อย",
    },
    markets: {
      title: "ตลาด",
      notices: "ประกาศจาก FISG",
      analysis: "การวิเคราะห์ FISG",
      calendar: "ปฏิทินเศรษฐกิจ",
      transaction: "การวิเคราะห์ธุรกรรม",
      news: "ข่าวด่วน",
      times: "FISG Times",
      marketWrap: "Market Wrap",
    },
    ctaTradeNow: "เริ่มเทรด",
    login: "เข้าสู่ระบบ",

    topTips1: "1 คะแนน (Point) เท่ากับ 1 Standard Lot หรือ 100 Cent Lot.",
    topTips2: "ยังไม่รองรับการแลกของจากภูมิภาคอื่นๆ.",
    topTips3:
      "ฉันยืนยันว่าคะแนนในระบบตรงกับจำนวนล็อตที่เทรดจริง และได้แลกรางวัลอย่างถูกต้อง.",
    topTips4:
      "ฉันเข้าใจว่าการแลกครั้งนี้จะเป็นโมฆะ หากบริษัทตรวจสอบพบว่าฉันใช้ข้อผิดพลาดของระบบที่อาจแสดงคะแนนไม่ตรงตามจริง.",
    remark: "หมายเหตุ",

    confirmAddress: "ยืนยันที่อยู่",
    cancel_btn: "ยกเลิก",

    setAsDefault: "ตั้งเป็นค่าเริ่มต้น",
    exchangeAccount: "บัญชีแลกเปลี่ยน",

    defaultAddress: "ค่าเริ่มต้น",

    exchangeAccount1: "เลือกบัญชีเทรด",

    exchangeAccount2: " เลือกบัญชีเทรดที่ต้องการรับเงินรางวัล",
  },
}
